import type { WorkoutQuestion } from "../../api/workout-service";

import Avatar from "../user/Avatar";
import useAuth from "../../hooks/useAuth";

export type UserAnswersProps = {
    question: WorkoutQuestion;
    index: number;
    show?: boolean;
};

export default function UserAnswers({ question, index, show }: UserAnswersProps) {
    const auth = useAuth();

    if (!show) return <></>

    const users = question.answers
        .filter(answer => answer.index === index)
        .filter(answer => answer.user !== auth.username)
        .map(answer => answer.user);

    return <>
        { users.map(user => <Avatar key={ user } userId={ user }/>) }
    </>
}
